<script>
  import { format } from 'svelte-i18n';

  import { fontBase, fontHeadings, fontWeightBase, fontWeightHeadings } from '@client/stores/brand';

  import Fonts from './typography-fonts.svelte';
</script>

<header>
  <h2>{$format('label.BRAND_WIZARD_STEP_TYPOGRAPHY')}</h2>
  <p class="mb-4">{$format('label.BRAND_WIZARD_STEP_TYPOGRAPHY_DESCRIPTION')}</p>
</header>

<h4>{$format('label.BRAND_FONT_HEADINGS')}</h4>
<Fonts bind:fontFamily={$fontHeadings} bind:fontWeight={$fontWeightHeadings} />

<h4 class="mt-4">{$format('label.BRAND_FONT_BASE')}</h4>
<Fonts bind:fontFamily={$fontBase} bind:fontWeight={$fontWeightBase} />
